export default __webpack_public_path__ + "static/media/15.0385a224.jpg";